import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import ViewBookingFormProperties from './ViewBookingFormProperties'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/PathMap_Helpdesk'

const {
  form: { CngViewForm }
} = components

function ViewBookingPage({ showNotification }) {
  const { id } = useParams()
  const history = useHistory()


  function onSubmit(data) {
    console.log('submityyy', data)


    history.push('/');
    history.replace({ pathname: pathMap.VIEW_BOOKING, state: data })
  }

  return (

    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <ViewBookingFormProperties.FormFields
          disabled={false}

          showNotification={showNotification}
        />
      }
      formikProps={{
        ...ViewBookingFormProperties.formikProps,
        onSubmit: onSubmit
      }}
    // toClientDataFormat={PollingFormProperties.toClientDataFormat}
    // toServerDataFormat={PollingFormProperties.toServerDataFormat}
    />

  )
}

export default ViewBookingPage
